__turbopack_context__.v({
  "footerNavLink": "FooterNav-module__03bIjG__footerNavLink",
  "footerNavList": "FooterNav-module__03bIjG__footerNavList",
  "footerNavTitle": "FooterNav-module__03bIjG__footerNavTitle",
});
